// extracted by mini-css-extract-plugin
export default {"note":"AppointmentSummaryNote_note__OzHEe","date-txt":"AppointmentSummaryNote_date-txt__9XKmP"};